import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { Business } from '../catalogs.model';
import { CatalogsService } from '../catalogs.service';

@Component({
  selector: 'app-catalogs-main',
  templateUrl: './catalogs-main.component.html',
  styleUrls: ['./catalogs-main.component.scss'],
})
export class CatalogsMainComponent implements OnInit {
  constructor(private errorHandlingService: ErrorHandlingService, private catalogsService: CatalogsService) {}
  connectedBusinesses: Business[];
  connectedCatalogs = [];
  isQueryOngoing = true;

  ngOnInit() {
    this.catalogsService
      .getConnectedBusinessManagers()
      .pipe(
        tap(response => {
          this.processConnectedBusinessesResult(response);
          this.isQueryOngoing = false;
        }),
        this.errorHandlingService.catchAlertAndThrowHttpError()
      )
      .subscribe();
  }

  hasConnectedBusinesses() {
    return this.connectedBusinesses.length !== 0;
  }

  processConnectedBusinessesResult(response) {
    this.connectedBusinesses = response.map(
      business =>
        ({
          ...business,
          linkToBusinessManager: `https://business.facebook.com/settings/info?business_id=${business.external_id}`,
          connected_by: business.connected_by.name,
          catalogs: business.catalogs.map(catalog => ({
            ...catalog,
            linkToBusinessManager: `https://business.facebook.com/commerce/catalogs/${catalog.external_id}/products?business_id=${business.external_id}`,
          })),
        } as Business)
    );
  }
}
